export type Kind = 'flowers' | 'balloons' | 'both'

export type PortfolioCategory =
  | 'weddings'
  | 'balloons'
  | 'celebrations'
  | 'centerpieces'
  | 'themed'
  | 'corporate'

export type ServiceSlug =
  | 'wedding-flowers'
  | 'balloon-arches'
  | 'centerpieces'
  | 'custom-arrangements'
  | 'themed-balloons'
  | 'celebration-combinations'

export type ServiceIcon = 'bouquet' | 'balloon' | 'centerpiece' | 'theme' | 'arrangement' | 'combo'

export const business = {
  name: 'Flores con Aroma de Café',
  phoneDisplay: '(240) 413-8201',
  phoneIntl: '+1 (240) 413-8201',
  phoneHref: 'tel:+12404138201',
  whatsappNumber: '12404138201',
  email: 'floresconaromatdecafe@gmail.com',
  city: 'Jessup, Maryland',
  rating: 5.0,
  reviewCount: 27,
  instagramHandle: '@floresconaromatdecafe',
  social: {
    instagram: 'https://instagram.com/floresconaromatdecafe',
    facebook: 'https://facebook.com',
  },
  mapEmbed: 'https://www.google.com/maps?q=Jessup,+Maryland&output=embed',
  directions: 'https://www.google.com/maps/dir/?api=1&destination=Jessup,+Maryland',
}

/** Real client photos. Replace `null` slots in `projects` below as new photos arrive. */
export const photos = {
  pastelBirthday: 'https://cdn.magicpatterns.com/uploads/cebuMpHdiLpTw1DGrBzjWW/IMG1.jpg',
  charroBirthday: 'https://cdn.magicpatterns.com/uploads/sQP2LpZC7c2ka8bSEpg29J/IMG2.jpg',
  sageWeddingArch: 'https://cdn.magicpatterns.com/uploads/6xyQUXGWHCmPDWwHi4BpsG/IMG3.jpg',
  sageWeddingPedestal: 'https://cdn.magicpatterns.com/uploads/howznz4kzq8f9RoPVFjjzE/IMG4.jpg',
  quinceOutdoor: 'https://cdn.magicpatterns.com/uploads/2cC8GmsiW4aD6sTfA2RzGC/IMG5.jpg',
  floralBanner: 'https://cdn.magicpatterns.com/uploads/aAghuAmgBcU1SzwAU9sLLw/Banner_Yeni_Flores.png',
}

export type ProjectMeta = {
  id: string
  /** `null` = empty slot waiting for a photo upload */
  image: string | null
  categories: PortfolioCategory[]
  kind: Kind
}

export const projects: ProjectMeta[] = [
  { id: 'p1', image: photos.sageWeddingArch, categories: ['weddings'], kind: 'flowers' },
  { id: 'p2', image: photos.pastelBirthday, categories: ['balloons', 'themed'], kind: 'both' },
  { id: 'p3', image: photos.quinceOutdoor, categories: ['celebrations', 'centerpieces'], kind: 'both' },
  { id: 'p4', image: photos.charroBirthday, categories: ['balloons', 'themed'], kind: 'balloons' },
  { id: 'p5', image: photos.sageWeddingPedestal, categories: ['weddings', 'centerpieces'], kind: 'flowers' },
  // Empty slots — paste the photo URL into `image` when ready
  { id: 'p6', image: null, categories: ['balloons', 'celebrations'], kind: 'balloons' },
  { id: 'p7', image: null, categories: ['weddings'], kind: 'flowers' },
  { id: 'p8', image: null, categories: ['balloons', 'celebrations'], kind: 'both' },
  { id: 'p9', image: null, categories: ['centerpieces'], kind: 'both' },
  { id: 'p10', image: null, categories: ['corporate'], kind: 'both' },
]

export type ServiceMeta = {
  slug: ServiceSlug
  kind: Kind
  icon: ServiceIcon
  image: string
  examples: PortfolioCategory[]
  showPalettes: boolean
}

export const serviceMeta: ServiceMeta[] = [
  {
    slug: 'wedding-flowers',
    kind: 'flowers',
    icon: 'bouquet',
    image: photos.sageWeddingArch,
    examples: ['weddings'],
    showPalettes: false,
  },
  {
    slug: 'balloon-arches',
    kind: 'balloons',
    icon: 'balloon',
    image: photos.pastelBirthday,
    examples: ['balloons'],
    showPalettes: true,
  },
  {
    slug: 'centerpieces',
    kind: 'flowers',
    icon: 'centerpiece',
    image: photos.sageWeddingPedestal,
    examples: ['centerpieces'],
    showPalettes: false,
  },
  {
    slug: 'themed-balloons',
    kind: 'balloons',
    icon: 'theme',
    image: photos.charroBirthday,
    examples: ['themed'],
    showPalettes: true,
  },
  {
    slug: 'custom-arrangements',
    kind: 'flowers',
    icon: 'arrangement',
    image: photos.floralBanner,
    examples: ['weddings', 'centerpieces'],
    showPalettes: false,
  },
  {
    slug: 'celebration-combinations',
    kind: 'both',
    icon: 'combo',
    image: photos.quinceOutdoor,
    examples: ['celebrations'],
    showPalettes: true,
  },
]

export const balloonPalettes: { id: 'pastel' | 'vibrant' | 'neutral'; colors: string[] }[] = [
  { id: 'pastel', colors: ['#f7c6d9', '#bfe8d4', '#d9c6f0', '#fbeeb0', '#bfe0f7'] },
  { id: 'vibrant', colors: ['#d6348a', '#5b2a86', '#1f8a5b', '#f2b705', '#e0482f'] },
  { id: 'neutral', colors: ['#ffffff', '#f3e7d3', '#d4a574', '#c9a24a', '#e8d5e0'] },
]

export type ReviewMeta = {
  id: string
  name: string
  initials: string
  rating: number
  kind: Kind
  onHome?: boolean
}

/**
 * Client names stay untranslated. r1–r6 come from the brief/Google;
 * r7–r10 are sample reviews — replace with real ones when available.
 */
export const reviewMeta: ReviewMeta[] = [
  { id: 'r1', name: 'Maritza Delgado', initials: 'MD', rating: 5, kind: 'flowers', onHome: true },
  { id: 'r2', name: 'Sarah Johnson', initials: 'SJ', rating: 5, kind: 'balloons', onHome: true },
  { id: 'r3', name: 'Isabella Martinez', initials: 'IM', rating: 5, kind: 'both', onHome: true },
  { id: 'r4', name: 'Ashley Brown', initials: 'AB', rating: 5, kind: 'both', onHome: true },
  { id: 'r5', name: 'Jeffrey Carias', initials: 'JC', rating: 5, kind: 'both' },
  { id: 'r6', name: 'Carlos Rivera', initials: 'CR', rating: 5, kind: 'flowers' },
  { id: 'r7', name: 'Daniela Rojas', initials: 'DR', rating: 5, kind: 'balloons' },
  { id: 'r8', name: 'Kevin Thompson', initials: 'KT', rating: 5, kind: 'balloons' },
  { id: 'r9', name: 'Lucía Hernández', initials: 'LH', rating: 5, kind: 'balloons' },
  { id: 'r10', name: 'Monique Davis', initials: 'MD', rating: 5, kind: 'both' },
]
